"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var Draft_1 = __importDefault(require("../../Discussion/Draft"));
var useReducer_1 = __importDefault(require("../utils/useReducer"));
var DNGrid_1 = require("./DNGrid");
var DNReducer_1 = require("./DNReducer");
var moment_1 = __importDefault(require("moment"));
var DNView = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var t = (0, react_i18next_1.useTranslation)().t;
    var DNId = useParams().match.params.DNId;
    var _k = (0, firestore_1.useDocument)(collectionsRef_1.DNsRef.doc(DNId)), DNSn = _k[0], DNLoading = _k[1];
    var DNData = ((_a = DNSn === null || DNSn === void 0 ? void 0 : DNSn.data()) !== null && _a !== void 0 ? _a : {});
    var _l = (0, firestore_1.useCollection)(collectionsRef_1.IRsRef.where("orderId", "==", (_b = DNData === null || DNData === void 0 ? void 0 : DNData.orderId) !== null && _b !== void 0 ? _b : "")), IRsn = _l[0], IRLoading = _l[1];
    var IRData = ((_c = IRsn === null || IRsn === void 0 ? void 0 : IRsn.docs[0].data()) !== null && _c !== void 0 ? _c : {});
    var POId = (_d = DNData.POId) !== null && _d !== void 0 ? _d : "asf";
    var _m = (0, firestore_1.useCollection)(collectionsRef_1.DNItemsRef.where("DNId", "==", DNId)), DNItemsSN = _m[0], DNtemsSNLoading = _m[1];
    var _o = (0, firestore_1.useDocument)(collectionsRef_1.POsRef.doc(POId)), POSN = _o[0], POSNLoading = _o[1];
    var POData = ((_e = POSN === null || POSN === void 0 ? void 0 : POSN.data()) !== null && _e !== void 0 ? _e : {});
    var RFQIdFromPO = (_g = (_f = POData.RFQId) !== null && _f !== void 0 ? _f : DNData === null || DNData === void 0 ? void 0 : DNData.RFQId) !== null && _g !== void 0 ? _g : "asf";
    var _p = (0, firestore_1.useDocument)(collectionsRef_1.RFQsRef.doc(RFQIdFromPO)), RFQSn = _p[0], RFQLoading = _p[1];
    var RFQsData = ((_h = RFQSn === null || RFQSn === void 0 ? void 0 : RFQSn.data()) !== null && _h !== void 0 ? _h : {});
    var _q = (0, firestore_1.useCollection)(collectionsRef_1.approvalsRef.where("formId", "==", DNId)), approvalsSN = _q[0], approvalsLoading = _q[1];
    var DNItems = ((_j = DNItemsSN === null || DNItemsSN === void 0 ? void 0 : DNItemsSN.docs) !== null && _j !== void 0 ? _j : []).map(function (doc) {
        return __assign(__assign({}, doc.data()), { id: doc.id });
    });
    var router = useParams();
    var _r = (0, useReducer_1.default)((0, DNReducer_1.getDNReducer)(router, t), null), state = _r[0], dispatch = _r[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var approvalsData, data;
            var _a;
            return __generator(this, function (_b) {
                if (DNLoading ||
                    DNtemsSNLoading ||
                    state ||
                    !DNData ||
                    approvalsLoading ||
                    POSNLoading ||
                    RFQLoading ||
                    IRLoading) {
                    return [2 /*return*/];
                }
                approvalsData = (_a = approvalsSN === null || approvalsSN === void 0 ? void 0 : approvalsSN.docs.map(function (e) {
                    return __assign({}, e.data());
                })) !== null && _a !== void 0 ? _a : [];
                data = {
                    IRData: IRData,
                    DNData: DNData,
                    DNItems: (0, lodash_1.sortBy)(DNItems, function (x) { return x.index; }),
                    POsData: POData,
                    RFQsData: RFQsData,
                    approvalsData: approvalsData,
                    DNId: DNId,
                    triedSubmitting: false,
                    approvedAtSignatureDate: (0, moment_1.default)(),
                };
                dispatch({ type: "init", payload: data });
                return [2 /*return*/];
            });
        }); })();
    }, [
        DNLoading,
        DNtemsSNLoading,
        DNData,
        DNItems,
        state,
        approvalsSN,
        DNId,
        approvalsLoading,
        POSNLoading,
        POData,
        RFQLoading,
        RFQsData,
    ]);
    var projectId = DNData.projectId;
    var DNParticipateInDiscussionPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "DNParticipateInDiscussion",
    ]);
    var DNViewDiscussionPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "DNViewDiscussion",
    ]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!approvalsSN || !state) {
            return;
        }
        dispatch({
            type: "update",
            payload: {
                path: "approvalsData",
                newValue: (_a = approvalsSN === null || approvalsSN === void 0 ? void 0 : approvalsSN.docs.map(function (e) {
                    return __assign({}, e.data());
                })) !== null && _a !== void 0 ? _a : [],
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [approvalsSN]);
    if (DNtemsSNLoading || DNLoading || !state || approvalsLoading) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, { size: "large" });
    }
    var mode = state.DNData.status === "draft" ? "edit" : "view";
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.orderContainer }, { children: [(0, jsx_runtime_1.jsx)(DNGrid_1.DNGrid, { state: state, dispatch: dispatch, mode: mode, DNId: DNId }), DNViewDiscussionPermission ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(index_modules_css_1.default.orderSection, " ").concat(index_modules_css_1.default.orderFooter) }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t("common.discussion") }), (0, jsx_runtime_1.jsx)(Draft_1.default, { kind: "DN", docId: DNId, viewInput: DNParticipateInDiscussionPermission })] }))) : null] })));
};
exports.DNView = DNView;
exports.default = exports.DNView;
